import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconIcon: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="icon"><path d="M21.25 6.75H2.75V20.25H21.25V6.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M7.75 6.75V2.75H16.25V6.75" stroke="currentColor" strokeWidth="1.5"/><path d="M9 13.5H15" stroke="currentColor" strokeWidth="1.5"/><path d="M12 10.5V16.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconIcon;
